import React, { useContext } from 'react';
import { Row, Col, Form, InputGroup } from 'react-bootstrap';

import { Text, TextColored } from '../../components/typography';

import { Progreso } from '../../assets/icons/card';
import { ProgresoMobile, Instructivo } from '../../assets/icons/card';
import mobile from '../../assets/images/mobile.png';
import Progress from "../progress/Progress";
import Advertencia from '../../assets/images/advertencia.png';

import { ThemeContext } from '../../theming';

import useWindowDimensions from '../../helpers/useWindowDimensions';
import NumberFormat from 'react-number-format';

function CardNegocio({ title, data, text, focusText = null, focusTextBlock = null, hlBlock = false, textBlock = null, hlMaxPay = false, table = {}, subtitle = null, footer = null, instructivos = [], icon = null, size = "md",
	mediosPagos = [], subTotal, setCorreoCliente, invalidCorreo = false, handleBlurCorreo = () => { }, focusCorreo = null, textCorreoInvalid = "Formato inválido", 
	correoCliente, onChangeMediosPagos = () => { }, buttonPagar = null, medioPagaSelected = null, progress = null, bloqueados = false }) {
	const app = useContext(ThemeContext);
	const { body14, body32, body12, body28 } = app.theme.font;
	const { width } = useWindowDimensions();

	const instructivoSiniestro = instructivos.find(instructivo => instructivo.nombre === "instructivo_siniestros");
	const icono = {
		top: '-20px',
		right: '21px',
		position: 'relative',
	};
	const iconoMobile = {
		top: '-50px',
		right: '21px',
		position: 'relative'
	};
	return (
		<>
			{width >= 701 && <Progreso style={width >= 701 ? icono : {}} />}
			<Row className={width >= 701 ? 'mt-5 mx-5 d-flex justify-content-center justify-content-xl-start align-items-center' :
				'd-flex justify-content-center justify-content-xl-start'}>
				{width >= 701 ?
					<>
						{icon && <Col className='d-flex justify-content-end align-items-center' xs={size === "xl" ? 1 : 2}>{icon}</Col>}
						<Col className='d-flex justify-content-start align-items-center' xs={3} xl={3}>
							<Text type='primary' size={body28}>
								{title}:
							</Text>
						</Col>
						<Col className='d-flex justify-content-start' xs={7} xl={7}>
							<TextColored className='text-justify' size={body12} type='gray' focusText={focusText}
								style={{
									padding: "6px",
									borderRadius: "5px",
									transition: "background-color 1s",
									transitionTimingFunction: "ease-in-out",
									transitionDelay: "0.5s",
									backgroundColor: hlMaxPay ? "rgba(253, 209, 53, 0.5)" : ""
								}}
							>
								{text}
							</TextColored>
						</Col>
						{instructivoSiniestro && <Col xs={12} xl={2} className='d-flex justify-content-end my-xl-auto mt-4 pr-0'>
							<a href={instructivoSiniestro.url} target="_blank" rel="noopener noreferrer">
								<Instructivo />
							</a>
						</Col>}
						<Col xs={12}>
						{progress && <div className={`mx-auto ${width >= 1200 ? "w-50":"w-100"}`}>
							<Progress progress={progress} />
						</div>}
						</Col>
						{
							bloqueados && <Col xs={12}  className='d-flex justify-content-center mt-5 pr-0'>
								<img src={Advertencia}
                    			 alt="Advertencia"
                    			 width="30px"
								 height="30px"
                    			 style={{ marginRight : 4}}
                    			/>
                    			<TextColored className='text-justify d-block w-50' size={0.6} type='gray' bold focusText={focusTextBlock}
								style={{
									padding: "6px",
									borderRadius: "5px",
									transition: "background-color 1s",
									transitionTimingFunction: "ease-in-out",
									transitionDelay: "0.5s",
									backgroundColor: hlBlock ? "rgba(253, 209, 53, 0.5)" : ""
								}}>
								{textBlock}
                    			</TextColored>
							</Col>
						}
					</>
					:
					// Mobile vista
					<Col style={{ marginLeft: '60px' }}>
						<Row style={{
							marginTop: '-15px',
							marginLeft: '-76px'
						}}>
							{<ProgresoMobile style={iconoMobile} />}
						</Row>
						<Row style={{ marginTop: '60px' }} className='d-flex justify-content-start align-items-center' xs={12}>
							<Text type='primary' size={body28}>
								{title}:
							</Text>
						</Row>
						<Row className='pr-4'>
							<TextColored className='text-justify' size={body12} type='gray' focusText={focusText}
								style={{
									padding: "6px",
									borderRadius: "5px",
									transition: "background-color 1s",
									transitionTimingFunction: "ease-in-out",
									transitionDelay: "0.5s",
									backgroundColor: hlMaxPay ? "rgba(253, 209, 53, 0.5)" : ""
								}}
							>
								{text}
							</TextColored>
						</Row>
						{instructivoSiniestro && <Row className='d-flex justify-content-end align-items-center mt-3 mr-0'  >
							<a href={instructivoSiniestro.url} target="_blank" rel="noopener noreferrer">
								<Instructivo />
							</a>
						</Row>}
						{progress && <div className="mx-auto w-95">
							<Progress progress={progress} />
						</div>}
						{
							bloqueados && <Col xs={12}  className='d-flex justify-content-center mt-5 pr-0'>
								<img src={Advertencia}
                    			 alt="Advertencia"
                    			 width="30px"
                    			 height="30px"
                    			 style={{ marginRight : 4}}
                    			/>
                    			<TextColored className='text-justify d-block w-75' size={0.6} type='gray' bold focusText={focusTextBlock}
								style={{
									padding: "6px",
									borderRadius: "5px",
									transition: "background-color 1s",
									transitionTimingFunction: "ease-in-out",
									transitionDelay: "0.5s",
									backgroundColor: hlMaxPay ? "rgba(253, 209, 53, 0.5)" : ""
								}}
								>
								{textBlock}
                    			</TextColored>
							</Col>
						}
						<Row className='mr-4'>
							<div style={{
								display: "flex",
								justifyContent: "flex-start"
							}}>
								{subtitle && <Text size={0.6} type='primary' bold>
									Nota:{' '}
								</Text>}
								<Text size={0.6} type='primary'>{subtitle}</Text>
							</div>
						</Row>
					</Col>

				}

			</Row>

			<div className={width >= 701 ? 'm-5' : ''} >
				<Row className='mt-5'>
					<Col>
						<div>
							{subtitle ? (
								<>
									{width >= 701 && <div style={{
										display: "flex",
										justifyContent: "flex-start"
									}}>
										<Text size={body14} type='primary' bold>
											Nota:{' '}
										</Text>
										<Text size={body14} type='primary'>{subtitle}</Text>
									</div>}

									<div className="info-mobile">
										<Col style={{
											display: "flex",
											justifyContent: "flex-end"

										}}>
											<Row>
												<img style={{ marginRight: "5px" }} height="35px" width="56px" alt="" src={mobile} />
												<p style={{
													fontSize: '9px',
													fontWeight: '900',
													marginTop: '6px'
												}}>Desliza la tabla para ver más información</p>
											</Row>
										</Col>
									</div>
								</>
							) : (
								footer
							)}
						</div>
						{table}
						{/* <Tabla numeroFilas={10} busqueda={false} datos={table}></Tabla> */}
					</Col>
				</Row>
				{!!mediosPagos.length && !!data.length && <><Row className={width >= 701 ? ' m-2 d-flex justify-content-between' : 'd-flex flex-column align-items-center'}>
					<Col xs={10} sm={10} md={5} >
						<Text type='primary' size={body28}>
							Transferencia Bancaria
						</Text>
						<TextColored className='text-justify d-block' size={body12} type='gray'>
							Ingrese su correo electronico y enviaremos los datos para la transferencia
						</TextColored>
						<TextColored className='text-justify d-block' style={{ textAlign: "end" }} size={body12} type='gray'>
							{`${correoCliente.length}/50`}
						</TextColored>
						<InputGroup hasValidation>
							<Form.Control
								name="correo"
								maxLength={50}
								type="email"
								placeholder="Correo para Comprobante *"
								value={correoCliente}
								isInvalid={invalidCorreo}
								//autoFocus={focusCorreo}
								ref={focusCorreo}
								onBlur={handleBlurCorreo}
								onKeyDown={(e) => { if (e.key == " ") { e.preventDefault(); return; } }}
								onChange={(e) => setCorreoCliente(e.target.value.toLocaleLowerCase().split(' ').join(''))}
							/>
							<Form.Control.Feedback type="invalid">
								{textCorreoInvalid}
							</Form.Control.Feedback>
						</InputGroup>
					</Col>
					<Col xs={10} sm={10} md={5}>
						<Text type='primary' size={body28}>
							Seleccione un medio de Pago
						</Text>
						<Row xs={1} md={2} >
							{mediosPagos.map((medio) => {
								return <Col className="mb-2">
									<Form.Check
										type="radio"
										id={`medio-radio-${medio.codCanalPago}`}
										//label={medio.name}
										className="d-flex align-items-center justify-content-center"
										name="medio_group"
									>
										<img src={medio.logo}
											alt={medio.name}
											style={{ width: "120px" }}
										/>
										<Form.Check.Input
											type="radio"
											value={medio.codCanalPago}
											onChange={onChangeMediosPagos}
											checked={medio.codCanalPago == medioPagaSelected}
											style={{ marginLeft: "12px" }}
										/>
									</Form.Check>
								</Col>
							})}
						</Row>


					</Col>
				</Row>
					<Row className='d-flex justify-content-end' >
						<TextColored className='w-auto' size={body28} type='gray' style={{ color: (subTotal != 0 & subTotal > mediosPagos.find(m => m.codCanalPago == medioPagaSelected)?.max_pay) ? "red" : "" }}>
							Total a Pagar: {<NumberFormat
								value={subTotal}
								displayType='text'
								prefix="$"
								thousandSeparator="."
								decimalScale={2}
								decimalSeparator=","
							/>}
						</TextColored>
					</Row>
					<Row className='d-flex justify-content-end mt-2'>
						{buttonPagar}
					</Row>
				</>}
			</div>

		</>
	);
}

export default CardNegocio;
